import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    entityName: "",
    municipalityName: "",
    entityId: null,
    municipalityId: null,
};

const sectionReducer = createSlice({
    name: "section",
    initialState,
    reducers: {
        setSectionData: (state, action) => {
            state.entityName = action.payload.entityName;
            state.municipalityName = action.payload.municipalityName;
            state.entityId = action.payload.entityId;
            state.municipalityId = action.payload.municipalityId;
        },
        clearSectionData: (state) => {
            state.entityName = "";
            state.municipalityName = "";
            state.entityId = null;
            state.municipalityId = null;
        },
    },
});

export const { setSectionData, clearSectionData } = sectionReducer.actions;
export default sectionReducer.reducer;
